<template>
    <div class="modal fade game-play-modal" id="gamesIframe" tabindex="-1" aria-labelledby="gamesModalLabel" aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false">
        <div class="modal-dialog modal-fullscreen" style="max-width: 100%;">
            <div v-if="gameData" class="modal-content">
                 <div class="modal-header"> 
                 <div class="flex_between_item">
                   <div class="back-arrow">
                        <a href="javascript:void(0)" @click="$emit('closeGame')">
                            <!-- <img src="@/assets/images/home-footer.png" alt="back-arrow" class="aff-home-btn" loading="lazy"/> -->
                             <i class="fa-solid fa-angle-left"></i>
                        </a>
                         <p class="para-four text-light casino_name">{{ gameData?.gameName }}</p>
                    </div>
                    
                    <div class="user_id">
                          <span class="u_id">{{ userData?.userid }}</span>
                          <div class="user_bf">
                             <img src="@/assets/images/user-cas.png" alt="user">
                          </div>
                    </div>
                  </div>  
                 </div>   
                <div class="modal-body">
                    <div class="game-iframe-sec">
                        <div v-if="this.gameData" class="iframe-content">
                            <iframe :src="this.gameData.gameUrl" frameborder="0"
                                style="overflow:hidden;overflow-x:hidden;overflow-y:hidden;height:100%;width:100%;position:absolute;top:0px;left:0px;right:0px;bottom:0px"
                                height="100%" width="100%" allow="autoplay; fullscreen; picture-in-picture"
                                allowfullscreen title="Tr&amp;eacute;ning TEXT"></iframe>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'IFrameModal',
    props: ['gameData', 'userData'],
}
</script>